@if (rows().length || customContent()) {
    @let headerItems = headersComputed();
    @let captionItems = caption();

    <div
        class="-webkit-overflow-scrolling:touch overflow-x-auto print:overflow-hidden! wrap-normal">
        <table [class]="tableClassComputed()">
            @if (captionItems) {
                <caption class="h5 mb-5 caption-top py-0 text-start">
                    {{ captionItems }}
                </caption>
            }
            @if (headerItems && headerItems.length > 0 && !(isMobile() && renderResponsive())) {
                @let isSortable = sortable();
                <thead>
                    <tr>
                        @for (header of headerItems; track header.key ?? header.value ?? i; let i = $index) {
                            <th
                                [attr.colspan]="header.colSpan"
                                [class]="header.class"
                                [style.width]="header.width"
                                (click)="onHeaderClicked(i)">
                                <div
                                    [class]="{
                                        'flex': isSortable,
                                        'items-center': isSortable,
                                        'justify-between': isSortable,
                                    } ">
                                    {{ header.value }}
                                    @if (isSortable) {
                                        <button class="flex flex-col gap-[1px]">
                                            <div
                                                class="h-0 w-0 border-t-0 border-r-[5px] border-b-[8px] border-l-[5px] border-solid border-transparent print:hidden"
                                                [class]="{
                                                    'border-b-primary-200': header.sortOrder !== 'asc',
                                                    'border-b-primary-50': header.sortOrder === 'asc',
                                                    'print:border-b-primary print:block': header.sortOrder === 'asc'
                                                }"></div>
                                            <div
                                                class="h-0 w-0 border-t-[8px] border-r-[5px] border-b-0 border-l-[5px] border-solid border-transparent print:hidden"
                                                [class]="{
                                                    'border-t-primary-200': header.sortOrder !== 'desc',
                                                    'border-t-primary-50': header.sortOrder === 'desc',
                                                    'print:border-t-primary print:block!': header.sortOrder === 'desc'
                                                }"></div>
                                            <span class="sr-only">
                                                {{ translateCell() }} {{ header.value }} {{
                                                    header.sortOrder === undefined || header.sortOrder === 'asc'
                                                        ? translateSortDescending()
                                                        : translateSortAscending()
                                                }}
                                            </span>
                                        </button>
                                    }
                                </div>
                            </th>
                        }
                    </tr>
                </thead>
            }
            <tbody class="border-t-0">
                @if (customContent()) {
                    <ng-content />
                } @else {
                    <ng-container *ngTemplateOutlet="tableBodyTempl; context: { rows: rowsComputed() }" />
                }
            </tbody>
        </table>
    </div>
}

<ng-template
    #tableBodyTempl
    let-rows="rows">

    @for (row of rows; track rowIndex; let
        rowIndex = $index) {
        <tr bigUiTableRow>
            @for (column of row; track $index; let isFirst = $first) {
                <td
                    bigUiTableCell
                    [customClasses]="column.cssClass"
                    [renderResponsive]="renderResponsive()"
                    [isFirst]="isFirst"
                    [attr.colspan]="column.colSpan"
                    [disableEvenOdd]="disableEvenOdd()"
                    [class]="{
                        'font-semibold': isFirst && highlightFirstColumn,
                    }">
                    @if (column.title) {
                        <div class="font-semibold w-full mb-2"
                             [innerHTML]="column.title | sanitize: sanitizeContext"></div>
                    }

                    @switch (column.type) {
                        @case ('component') {
                            <ng-container *ngComponentOutlet="column.value.type; inputs: column.value.inputs"></ng-container>
                        }
                        @case ('link') {
                            <big-ui-link
                                [href]="column.value.href"
                                [linkClass]="'after:content-none'">
                                {{ column.value.title ?? translateLabelEdit() }}
                            </big-ui-link>
                        }
                        @case ('image') {
                            <big-ui-picture
                                [model]="column.value"
                                class="block" />
                        }
                        @case ('html') {
                            <span [innerHTML]="column.value ?? '' | sanitize: sanitizeContext"></span>
                        }
                        @case ('date') {
                            <span [innerHTML]="(column.value | date: (column.format ?? 'dd.MM.y')) ?? '' | nl2br"></span>
                        }
                        @case ('icon-button') {
                            <big-ui-button
                                [buttonStyle]="'tertiary icon'"
                                [classList]="column.buttonClassList ?? []"
                                [title]="column.labelKey"
                                (clicked)="column.onIconButtonClickHandler(rowIndex)">
                                <big-icon
                                    [icon]="iconMap[column.iconName]!"
                                    [size]="column.iconSize ? column.iconSize : 'w-4'"
                                    [class]="column.iconClassList"
                                    class="not-sr-only" />
                                <span class="sr-only">{{ column.labelKey }}</span>
                            </big-ui-button>
                        }
                        @default {
                            <span>{{ column.value ?? '' }}</span>
                        }
                    }
                </td>
            }
        </tr>
    }
</ng-template>
